import { Component, defineComponent } from '@decify/cell-shopify/client';
import { Button, buttonTagName } from '../Button';
import './CartForm.scss';
export const CartFormName = 'CartForm';
export const CartFormTagName = 'cell-component-cart-form';
export class CartForm extends Component {
    constructor() {
        super('CartForm');
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentDidMount() {
        this.formElement.subscribe('submit', this.handleSubmit);
    }
    async handleSubmit() {
        this.buttonElement.setLoading(true, {
            // IMPORTANT! Do not actually set the button to `disabled` when loading as this would
            // redirect the user to the cart page instead of the checkout.
            disable: false,
        });
    }
    get formElement() {
        const formElement = this.querySelector('form');
        if (!formElement) {
            throw new Error('Form element not found');
        }
        return formElement;
    }
    get buttonElement() {
        const buttonElement = this.querySelector(buttonTagName);
        if (!buttonElement || !(buttonElement instanceof Button)) {
            throw new Error('Button element not found');
        }
        return buttonElement;
    }
}
defineComponent('cell-component-cart-form', CartForm);
